import { AgxBadge } from '@urbanx/agx.ui-components2'
import { getDueDateBadgeState } from 'utils/tasks'

interface TaskDueDateBadgeProps {
  dueDate: string
  isCompleted: boolean
}

const TaskDueDateBadge = ({ dueDate, isCompleted }: TaskDueDateBadgeProps) => {
  const badge = getDueDateBadgeState(dueDate, isCompleted)

  if (badge.type === 'highlighted') {
    return (
      <AgxBadge
        type="highlighted"
        colour={badge.color}
        size="md"
        text={badge.text}
        highlightText={badge.highlightText}
      />
    )
  }

  return (
    <AgxBadge
      type="colourfill"
      colour={badge.color}
      size="md"
      text={badge.text}
    />
  )
}

export default TaskDueDateBadge
